import React, {useEffect} from "react";
import {useAuthManager} from "../components/utils/auth";
import {Box, CircularProgress, Typography} from "@mui/material";

export default function Logout() {
    const authManager = useAuthManager();

    useEffect(() => {
        authManager.doLogout();
    }, []);

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', py: 5}}>
            <CircularProgress size={60} sx={{mb: 3}}/>
            <Typography variant="body1">
                Cerrando sesión...
            </Typography>
        </Box>
    );
}
